import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useNavigate } from 'react-router-dom';

const J = {
    text: '#66b2ff',
    accent: '#66b2ff',
    muted: '#a3d1ff',
};

/**
 * Page header with home button and title.
 * @param {string} title - Page title
 * @param {string} subtitle - Optional subtitle
 * @param {boolean} hideIcon - Hide the home icon if true
 */
export default function PageHeader({ title, subtitle, hideIcon = false }) {
    const navigate = useNavigate();

    return (
        <Box id="page-header-root" mb={2}>
            <Box id="page-header-title-row" display="flex" alignItems="center" justifyContent="center" gap={1} mb={1}>
                {!hideIcon && (
                    <IconButton
                        id="page-header-home-btn"
                        onClick={() => navigate('/')}
                        size="small"
                        disableRipple
                        sx={{
                            color: J.accent,
                            '&:hover': { bgcolor: 'transparent', opacity: 0.8 },
                        }}
                    >
                        <HomeOutlinedIcon />
                    </IconButton>
                )}
                <Typography
                    id="page-header-title"
                    variant="h4"
                    sx={{
                        color: J.text,
                        fontFamily: "'Plus Jakarta Sans', sans-serif",
                        fontWeight: 700,
                        fontSize: { xs: '1.3rem', md: '2.125rem' },
                    }}
                >
                    {title}
                </Typography>
            </Box>

            {subtitle && (
                <Typography
                    id="page-header-subtitle"
                    variant="caption"
                    sx={{
                        textAlign: 'center',
                        color: J.muted,
                        opacity: 0.6,
                        fontSize: { xs: '0.85rem', md: '1.1rem' },
                        display: 'block',
                        ml: 5,
                    }}
                >
                    {subtitle}
                </Typography>
            )}
        </Box>
    );
}
